import React from 'react'
import styles from "./Input-style.module.css";

function DateInput({ id = null,
  actualDate = null,
  user = null,
  type = null,
  value = null,
  label = null,
  onChange = null,
  name = null,
  maxLength = null,
  errorMsg = null,
  isValid = null,
  elmentconfig = null,
  labelPosition = null,
  onClick = null,
  fieldvalidation = null, }) {
  // Future Date Restrictions
  let today = new Date()
  let dd = today.getDate();
  let mm = today.getMonth() + 1; //January is 0!
  const yyyy = today.getFullYear();

  if (dd < 10) {
    dd = '0' + dd;
  }

  if (mm < 10) {
    mm = '0' + mm;
  }

  function isMajor(birthDate) {
    var birthDate = new Date(birthDate);
    var age = today.getFullYear() - birthDate.getFullYear();
    var monthDiff = today.getMonth() - birthDate.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age > 18 && birthDate.getFullYear() + '-' + birthDate.getMonth() + '-' + birthDate.getDate();
  }

  today = user == "guardian" ? yyyy - 18 + '-' + mm + '-' + dd : yyyy + '-' + mm + '-' + dd;
  let minRange = user == "reports" ? yyyy - 2 + '-' + mm + '-' + dd : '1900-01-01'

  return (
    <React.Fragment>
      <>
        <div className={`intro-y g-col-12 g-col-md-6 g-col-xl-4 px-8 `}>
          <div className={styles.form__group}>
            <input
              name={name}
              onChange={onChange}
              value={value}
              type="date"
              id={id}
              className={`${styles.form__field} ${!isValid ? styles.error_field : ""
                }`}
              placeholder={label}
              maxLength={maxLength}
              aria-label={name}
              fieldvalidation={fieldvalidation}
              max={`${actualDate ? "" : today}`}
              min={minRange}
            />
            <label
              htmlFor={id}
              className={`${styles.input_label} ${styles.form__label}`}
            >
              {label}
            </label>
            <span
              className={`${!isValid ? styles.errorMsg : styles.errorMsgnot}`}
            >
              {errorMsg}
            </span>
          </div>
        </div>
      </>
      {/* <span className="datepicker-toggle">
        <span className="datepicker-toggle-button"></span>
        <label htmlFor={id} className="form-label">{label}</label>
        <input id={id} name={name} onChange={onChange} type="date"  className="form-control datepicker-input" />
      </span> */}
    </React.Fragment>
  )
}

export default DateInput